import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthProvider, useNotify } from 'react-admin';

const PUBLIC_URL = (new URL('/login/', window.location.href)).href;
let lastOTP = '';

export const LoginPage: React.FC = () => {
    const authProvider = useAuthProvider();
    const notify = useNotify();
    const navigate = useNavigate();
    const { searchParams } = new URL(window.location.href);
    const otp = searchParams.get('otp');

    useEffect(() => {
        if (!otp || lastOTP === otp)
            return;
        lastOTP = otp;
        authProvider?.login({ otp })
            .then(({ redirectTo }: any) => {
                console.log('Login successful, redirecting to:', redirectTo);
                // Remove OTP from URL before navigating
                const cleanUrl = new URL(window.location.href);
                cleanUrl.searchParams.delete('otp');
                window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search);
                navigate(redirectTo || '/', { replace: true });
            })
            .catch((e: Error) => {
                notify(e.message);
                window.location.href = 'https://hello2.songtek.net/auth/?redirectToPath=/Goto/' + btoa(PUBLIC_URL);
            });
    }, [authProvider, navigate, notify, otp]);

    if (!otp) {
        window.location.href = 'https://hello2.songtek.net/auth/?redirectToPath=/Goto/' + btoa(PUBLIC_URL);
        return <p>Redirecting ... </p>;
    }

    return (
        <p>Authenticating ... </p>
    );
};
